import { requests } from './DefaultRequest'

export const CrawlerRequest = {
  getCredentials: () =>
    requests.get('/api/v1/crawler/credentials'),

  verifyCredentials: (username, password, rememberPassword = true) =>
    requests.post('/api/v1/crawler/credentials/verify', {
      username,
      password: password || undefined,
      remember_password: rememberPassword,
    }),

  startCrawl: payload =>
    requests.post('/api/v1/crawler/crawl/start', payload),

  syncUsers: (username, wait = true) =>
    requests.post('/api/v1/crawler/sync/users', {
      username,
      wait,
    }),

  getImsatBookGroups: (username, token) =>
    requests.get('/api/v1/crawler/imsat/book-groups', {
      params: { username },
      headers: token ? { 'X-Imsat-Token': token } : {},
    }),

  getImsatBooks: (bookGroupId, username, token) =>
    requests.get(`/api/v1/crawler/imsat/books/${bookGroupId}`, {
      params: { username },
      headers: token ? { 'X-Imsat-Token': token } : {},
    }),

  getImsatAuthorityIssueds: (username, token) =>
    requests.get('/api/v1/crawler/imsat/authority-issueds', {
      params: { username },
      headers: token ? { 'X-Imsat-Token': token } : {},
    }),

  createImsatAuthorityIssued: (name, username, token) =>
    requests.post(
      '/api/v1/crawler/imsat/authority-issueds',
      { name, type: 'OUTGOING' },
      {
        params: { username },
        headers: token ? { 'X-Imsat-Token': token } : {},
      }
    ),

  getImsatUsers: (keyword, username, token) =>
    requests.get('/api/v1/crawler/imsat/users', {
      params: { keyword, username },
      headers: token ? { 'X-Imsat-Token': token } : {},
    }),

  createImsatOutgoing: (payload, token) =>
    requests.post('/api/v1/crawler/imsat/create-outgoing', payload, {
      headers: token ? { 'X-Imsat-Token': token } : {},
    }),
}

export default CrawlerRequest
